module.exports = __webpack_public_path__ + "img/新闻中心.96e46e07.jpg";